import dayjs from "dayjs";

const DateFormatter = (date) => {
  return dayjs(date).format("DD MMM YYYY");
};

export default DateFormatter;
